import { getAdminAxiosInstance } from "../../../api/Admin";

export const deleteContactInfo = async (id) => {
  const api = await getAdminAxiosInstance();
  try {
    const response = await api.get(`/contact/destroy?contact_id=${id}`);
    return response;
  } catch (error) {
    return error?.response?.data;
  }
};

export const updateContactInfo = async (params) => {
  const api = await getAdminAxiosInstance();
  try {
    const response = await api.post(`/contact/update`, params);
    return response;
  } catch (error) {
    return error?.response?.data;
  }
};
